import CompleteRegistration from "./CompleteRegistration";

export default function EditAccount() {
  return <CompleteRegistration mode="edit" />;
}
